import React from 'react';

import DatasetConfiguration from './DatasetConfiguration';
import ExpenseConfiguration from './ExpenseConfiguration';
import RetirementAgeConfiguration from './RetirementAgeConfiguration';
import SeatLockPeriodConfiguration from './SeatLockPeriodConfiguration';
import TrainingLockConfiguration from './TrainingLockConfiguration';

const ModelConfigurationView = () => (
  <div className="flex flex-col gap-3 overflow-y-hidden">
    <h1 className="text-2xl font-bold pb-4">Configuration</h1>
    <DatasetConfiguration />
    <div className="my-3 rounded-full border border-[#CCC]" />
    <RetirementAgeConfiguration />
    <div className="my-3 rounded-full border border-[#CCC]" />
    <SeatLockPeriodConfiguration />
    <div className="my-3 rounded-full border border-[#CCC]" />
    <TrainingLockConfiguration />
    <div className="my-3 rounded-full border border-[#CCC]" />
    <ExpenseConfiguration />
  </div>
);

export default ModelConfigurationView;
